import { Component, OnInit, ViewChild } from '@angular/core';
import { NgModel, NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import{ Location } from '@angular/common';


import { TopicService } from '../topic.service';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { NumberCardsService } from '../number-cards.service';
import { TSuperExerciseComponent } from '../t-super-exercise/t-super-exercise.component';


@Component({
  selector: 'app-tnumber-cards',
  templateUrl: './tnumber-cards.component.html',
  styleUrls: ['./tnumber-cards.component.css']
})
export class TnumberCardsComponent extends TSuperExerciseComponent{

  requestedNumber: number = 0;
  helptext: string = "symbols";
  showColoring: boolean=false;
  cards: number[] = [];
  private count: number[] = [];

  constructor(protected activatedRoute: ActivatedRoute, protected numberCardsService: NumberCardsService, protected topicService: TopicService, protected _location: Location) {
    super(activatedRoute, numberCardsService, topicService);
    this.type = "numberCards";
    this.title = this.get("numberCardsName");
  }

  /** sets information based on configuration */
  setInformationWithConfiguration(){
    super.setInformationWithConfiguration();
    this.requestedNumber = this.configuration.typespecifics.requestedNumber;
    if(this.configuration.typespecifics.showColoring){
      this.showColoring = this.configuration.typespecifics.showColoring;
    }
    this.onChangeRepr();
  }


  /** sets the counts correctly  */
  onChangeRequestedNumber() {
    if (this.representationDefined()) {
      this.requestedNumber = Math.floor(this.requestedNumber);
      let solution = this.numberCardsService.getSolution(this.requestedNumber, this.cards);
      let index = 0;
      for (let card of this.cards) {
        this.count[card] = solution[index];
        index++;
      }
    }
  }
  /** computes and sets the cards */
  onChangeRepr() {
    if(this.representation == 'nary'){
      this.representationSpec = Math.floor(this.representationSpec);
    }
    super.onChangeRepr();
    this.onChangeRequestedNumber();
  }



  /** adds a card of the given value 
   * @param {number} card - value of card to add
  */
  addedCard(card: number): void {
    this.count[card]++;
    this.requestedNumber += +card;
    this.onChangeRequestedNumber();
  }

  /** removes a card of the given value 
   * @param {number} card - value of card to remove
  */
  removeCard(card: number): void {
    this.count[card]--;
    this.requestedNumber -= +card;
  }

  /** resets all the variables */
  reset(){
    this.title = this.get("numberCardsName");
    this.description = "";
    this.id= undefined;
    this.representation = undefined;
    this.representationSpec = "";
    this.requestedNumber = undefined;
    this.helptext = "symbols";
    this.showColoring = false;
    this.cards = [];
    this.count = [];
  }

  /** generate the exercise automatically */
  generate() {
    super.generate();
    this.requestedNumber = Math.floor(Math.random() * this.maxNumber());
    this.title = this.get("cardRepresentation");
    this.onChangeRepr();
    this.onChangeRequestedNumber();
  }

  /** generate the exercise definition */
  generateDefinition(): any {
    let definition = super.generateDefinition();
    definition.key="dataRepresentation%cardRepresentation%";
    if(this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.key = definition.key.concat(this.representation, "%", this.representationSpec.toString().replace(new RegExp(" ", 'g'), ""), "%", this.requestedNumber.toString());
    definition.typespecifics.requestedNumber = this.requestedNumber;
    definition.typespecifics.showColoring = this.showColoring;
    definition.level = (this.showColoring?1:2);
    return definition;
  }

  /** checks whether all required fields are defined */
  allDefined(): boolean {
    if (this.title == undefined || this.title == "") {
      return false;
    }
    if (this.representation == undefined) {
      return false;
    }
    if(!this.representationDefined()){
      return false;
    }
    if (this.requestedNumber == undefined) {
      return false;
    }
    return true;
  }

  /** checks for decimal representation */
  decimal():boolean{
    if(this.representation == "nary"){
      if(this.representationSpec == 10){
        return true;
      }
    }
    return false;
  }

  /** returns the color for the coloring, based on the index */
  getColor(index:number):string{
    switch(index){
      case 0: return "green"; 
      case 1: return "hotpink"; 
      case 2: return "mediumblue"; 
      case 3: return "orange"; 
      case 4: return "00ff00"; 
      case 5: return "0000ff"; 
    }
  }

}
